<template>
	<div>
		<div class="row mb-3">
			<div class="col-lg-3">
				<label>N° de Estimación *</label>
				<input type="text" class="form-control" v-model="ProyectoEstimacion.NumEstimacion" placeholder="N° de Estimación"/>
				<Cvalidation v-if="this.errorvalidacion.NumEstimacion" :Mensaje="errorvalidacion.NumEstimacion[0]"></Cvalidation>
			</div>
			<div class="col-lg-3">
				<label>Fecha *</label>
				<v-date-picker v-model="ProyectoEstimacion.Fecha" :mode="typeCalendar"
					:popover="{
						placement: 'bottom',
						visibility: 'click'
					}"
					:input-props="{
						class: 'form-control cal-black',
						style: 'cursor:pointer;'
					}"
                    :locale="'es-MX'"
				/>
			</div>
			<div class="col-lg-3">
				<label>Valor *</label>
				<vue-numeric
					class="form-control "
					currency="$"
					separator=","
					placeholder="$0"
					:precision="0"
					v-model="ProyectoEstimacion.Valor"
				></vue-numeric>
				<Cvalidation v-if="this.errorvalidacion.Valor" :Mensaje="errorvalidacion.Valor[0]"></Cvalidation>
			</div>
			<div class="col-lg-2">
				<label>Crédito *</label>
				<vue-numeric
					class="form-control w-50"
					separator=","
					placeholder="0"
					:precision="0"
					v-model="ProyectoEstimacion.Credito"
				></vue-numeric>
				<Cvalidation v-if="this.errorvalidacion.Credito" :Mensaje="errorvalidacion.Credito[0]"></Cvalidation>
			</div>
		</div>
		<div class="row mb-3">
			<div class="col-lg-3 pr-0" style="flex-basis:28%;max-width:28%">
				<label>Realizó</label>
				<input type="text" class="form-control" v-model="ProyectoEstimacion.Realizo" placeholder="Realizó"/>
				<Cvalidation v-if="this.errorvalidacion.Realizo" :Mensaje="errorvalidacion.Realizo[0]"></Cvalidation>
			</div>
			<div class="col-lg-3 pr-0" style="flex-basis:28%;max-width:28%">
				<label>Aprueba</label>
				<input type="text" class="form-control" v-model="ProyectoEstimacion.Aprueba" placeholder="Aprueba"/>
				<Cvalidation v-if="this.errorvalidacion.Aprueba" :Mensaje="errorvalidacion.Aprueba[0]"></Cvalidation>
			</div>
			<div class="col-lg-3" style="flex-basis:22%">
				<label>Aprobación *</label>
				<v-date-picker v-model="ProyectoEstimacion.FechaAprobacion" :mode="typeCalendar"
					:popover="{
						placement: 'bottom',
						visibility: 'click'
					}"
					:input-props="{
						class: 'form-control cal-black',
						style: 'cursor:pointer;'
					}"
                    :locale="'es-MX'"
				/>
			</div>
			<div class="col-lg-3 pl-0" style="flex-basis:22%">
				<label>Factura *</label>
				<v-date-picker v-model="ProyectoEstimacion.FechaFactura" :mode="typeCalendar"
					:popover="{
						placement: 'bottom',
						visibility: 'click'
					}"
					:input-props="{
						class: 'form-control cal-black',
						style: 'cursor:pointer;'
					}"
                    :locale="'es-MX'"
				/>
			</div>
		</div>
		<div class="row">
			<div class="col-lg-6">
				<label>Descripción</label>
				<textarea v-model="ProyectoEstimacion.Descripcion" class="form-control" placeholder="Descripción" cols="30" rows="4"></textarea>
			</div>
			<div class="col-lg-6">
				<label>Observaciones</label>
				<textarea v-model="ProyectoEstimacion.Observaciones" class="form-control" placeholder="Observaciones" cols="30" rows="4"></textarea>
			</div>
		</div>
	</div>
</template>

<script>
import Cvalidation from '@/components/Cvalidation.vue'
export default {
	name:"Estimacion",
    props:["poBtnSave","pIdProyecto"],
	components:{Cvalidation},
	data() {
		return {
			Modal:true,
            FormName:'Estimacion',
            EmitSeccion:this.poBtnSave.EmitSeccion,
			ProyectoEstimacion:{
				IdProyectoEstimacion:0,
				IdProyecto:0,
				NumEstimacion:'',
				Fecha:'',
				Valor:'',
				Credito:'',
				Realizo:'',
				Aprueba:'',
				FechaAprobacion:'',
				FechaFactura:'',
				Descripcion:'',
				Observaciones:''
			},
			errorvalidacion:[]
		}
	},
	methods: {
		Guardar(){
			let Fecha='';
			let FechaAprobacion='';
			let FechaFactura='';
			if (this.ProyectoEstimacion.Fecha!='' && this.ProyectoEstimacion.Fecha!=undefined) {
                let day=this.ProyectoEstimacion.Fecha.getDate();
                let month=this.ProyectoEstimacion.Fecha.getMonth()+1;
                let year=this.ProyectoEstimacion.Fecha.getFullYear();
                Fecha=year+'-'+month+'-'+day;   
            }
			if (this.ProyectoEstimacion.FechaAprobacion!='' && this.ProyectoEstimacion.FechaAprobacion!=undefined) {
                let day=this.ProyectoEstimacion.FechaAprobacion.getDate();
                let month=this.ProyectoEstimacion.FechaAprobacion.getMonth()+1;
                let year=this.ProyectoEstimacion.FechaAprobacion.getFullYear();
                FechaAprobacion=year+'-'+month+'-'+day;   
            }
			if (this.ProyectoEstimacion.FechaFactura!='' && this.ProyectoEstimacion.FechaFactura!=undefined) {
                let day=this.ProyectoEstimacion.FechaFactura.getDate();
                let month=this.ProyectoEstimacion.FechaFactura.getMonth()+1;
                let year=this.ProyectoEstimacion.FechaFactura.getFullYear();
                FechaFactura=year+'-'+month+'-'+day;   
            }
			let formData=new FormData();
            formData.set('IdProyectoEstimacion',this.ProyectoEstimacion.IdProyectoEstimacion);
			formData.set('NumEstimacion',this.ProyectoEstimacion.NumEstimacion);
			formData.set('Fecha',Fecha);
			formData.set('Valor',this.ProyectoEstimacion.Valor);
			formData.set('Credito',this.ProyectoEstimacion.Credito);
			formData.set('Realizo',this.ProyectoEstimacion.Realizo);
			formData.set('Aprueba',this.ProyectoEstimacion.Aprueba);
			formData.set('FechaAprobacion',FechaAprobacion);
			formData.set('FechaFactura',FechaFactura);
			formData.set('Descripcion',this.ProyectoEstimacion.Descripcion);
			formData.set('Observaciones',this.ProyectoEstimacion.Observaciones);
			formData.set('IdProyecto',this.ProyectoEstimacion.IdProyecto);
			this.poBtnSave.toast=0;
            this.poBtnSave.disableBtn=true;
			this.$http.post('proyectoestimacion/post',formData,{
				headers:{
                    'Content-Type':'multipart/form-data'
                }
			}).then((res)=>{
                this.poBtnSave.disableBtn=false; 
                this.poBtnSave.toast=1;
                $("#Estimacion").modal("hide");
				this.bus.$emit('List');
                this.bus.$emit('ListaPrincipal');
            }).catch((err)=>{
                this.errorvalidacion=err.response.data.message.errores;
                this.poBtnSave.disableBtn=false;
                this.poBtnSave.toast=2;
            });
		},
		Limpiar(){
			this.ProyectoEstimacion={
				IdProyectoEstimacion:0,
				IdProyecto:0,
				NumEstimacion:'',
				Fecha:new Date(),
				Valor:'',
				Credito:'',
				Realizo:'',
				Aprueba:'',
				FechaAprobacion:new Date(),
				FechaFactura:new Date(),
				Descripcion:'',
				Observaciones:''
			};
			this.errorvalidacion=[];
		},
		Recuperar(){
			this.$http.get('proyectoestimacion/recovery',{
                params:{
                    IdProyectoEstimacion:this.ProyectoEstimacion.IdProyectoEstimacion
                }
            }).then((res)=>{
				const objres=res.data.data.proyectoestimacion;
				this.ProyectoEstimacion.IdProyectoEstimacion=objres.IdProyectoEstimacion;
				this.ProyectoEstimacion.IdProyecto=objres.IdProyecto;
				this.ProyectoEstimacion.NumEstimacion=objres.NumEstimacion;
				let formatedDate = objres.Fecha.replace(/-/g, "\/");
				this.ProyectoEstimacion.Fecha=new Date(formatedDate);
				this.ProyectoEstimacion.Valor=objres.Valor;
				this.ProyectoEstimacion.Credito=objres.Credito;
				this.ProyectoEstimacion.Realizo=objres.Realizo;
				this.ProyectoEstimacion.Aprueba=objres.Aprueba;
				let formatedDate2 = objres.FechaAprobacion.replace(/-/g, "\/");
				this.ProyectoEstimacion.FechaAprobacion=new Date(formatedDate2);
				let formatedDate3 = objres.FechaFactura.replace(/-/g, "\/");
				this.ProyectoEstimacion.FechaFactura=new Date(formatedDate3);
				this.ProyectoEstimacion.Descripcion=objres.Descripcion;
				this.ProyectoEstimacion.Observaciones=objres.Observaciones;
			});
		}
	},
	created() {
		this.bus.$off("NewModal_"+this.EmitSeccion);
        this.bus.$on("NewModal_"+this.EmitSeccion,(data,Id,IdProyecto)=>{
            this.poBtnSave.disableBtn=false;
            this.bus.$off("Save_"+this.EmitSeccion);
            this.bus.$on("Save_"+this.EmitSeccion, () => {
				this.Guardar();
			});
            this.Limpiar();
            if (IdProyecto!==undefined) {
                this.ProyectoEstimacion.IdProyecto=IdProyecto;
            }
            if (Id > 0) {
				this.ProyectoEstimacion.IdProyectoEstimacion = Id;
				this.Recuperar();
			}
        });
	},
	computed:{
        typeCalendar:function(){
            return 'single';
        }
    }
}
</script>

<style>

</style>
